import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Share2, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { openShare } from "@/lib/share";
import { whenFree } from "@/lib/popupQueue";
import { useGrowth } from "@/lib/growth";

const CUTOFF = "2026-11-05T00:00:00";
const MSG = "Aus der Itzcouple Community wird itzPlay! 💖 Neuer Name, neues Logo – dieselbe herzliche Community mit Spielen, Punkten und echten Prämien. Komm dazu:";

function Sheet({ onClose }) {
  const share = () => { onClose(); openShare({ kind: "invite", text: "rebrand", title: "itzPlay teilen", msg: MSG }); };
  return createPortal(
    <div role="dialog" aria-modal="true" aria-label="Neuer Name" onClick={(e) => e.target === e.currentTarget && onClose()} style={{ pointerEvents: "auto" }} className="fixed inset-0 z-[140] bg-black/60 backdrop-blur-sm flex items-center justify-center p-5" data-testid="rebrand-popup">
      <div className="relative w-full max-w-[340px] max-h-[86dvh] overflow-y-auto bg-[#fff7f9] rounded-[28px] shadow-2xl fade-rise text-center">
        <button type="button" onClick={onClose} aria-label="Schließen" data-testid="rebrand-x" className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 shadow flex items-center justify-center text-slate-600"><X className="w-4 h-4" /></button>
        <div className="relative overflow-hidden px-5 pt-6 pb-4 rb-hero">
          <div className="relative mx-auto w-16 h-16">
            <span className="absolute inset-0 rounded-[26%] rb-ring" aria-hidden />
            <img src="/logo-mark.png?v=6" alt="itzPlay Logo" className="relative w-16 h-16 rounded-[23%] shadow-[0_12px_28px_rgba(225,29,72,.4)] rb-pop" data-testid="rebrand-logo" />
          </div>
          <h2 className="hero-plain mt-3 font-display text-xl leading-tight font-black text-slate-900" data-testid="rebrand-title">
            Aus <span className="line-through decoration-rose-400/70 decoration-2 text-slate-400">Itzcouple Community</span><br />wird <span className="text-slate-900">itz</span><span className="text-rose-500">Play</span>
          </h2>
          <p className="mt-1.5 text-xs text-slate-500">Neuer Name, neues Logo – deine Freunde, Punkte und Prämien bleiben.</p>
        </div>
        <div className="px-5 pb-5 space-y-2.5">
          <p className="rounded-2xl bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-900" data-testid="rebrand-bonus-hint">🎁 <b>+20 Bonus:</b> Teile die Neuigkeit – meldet sich darüber ein Freund an, bekommst du 20 Punkte.</p>
          <button type="button" onClick={share} data-testid="rebrand-share" className="w-full h-11 rounded-full bg-rose-600 text-white font-extrabold text-sm inline-flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"><Share2 className="w-4 h-4" /> Neuigkeit teilen</button>
          <button type="button" onClick={onClose} data-testid="rebrand-close" className="w-full h-10 rounded-full bg-white border border-pink-200 text-rose-600 font-bold text-sm">Los geht's</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export function RebrandShareCard() {
  const g = useGrowth();
  if (!g || g.rebrand_bonus) return null;
  return (
    <section className="rounded-3xl p-5 border border-pink-100 bg-white shadow-sm flex items-center gap-4" data-testid="rebrand-share-card">
      <img src="/logo-mark.png?v=6" alt="itzPlay" className="w-14 h-14 rounded-2xl shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-bold text-slate-800">Namens-Bonus: +{g.rebrand_points} Punkte</p>
        <p className="text-xs text-slate-500 mt-0.5">Teile „Aus Itzcouple Community wird itzPlay“ – meldet sich darüber ein Freund an, gibt es einmalig den Bonus.</p>
      </div>
      <button onClick={() => openShare({ kind: "invite", text: "rebrand", title: "itzPlay teilen", msg: MSG })} data-testid="rebrand-share-card-btn" className="shrink-0 h-10 px-4 rounded-full bg-rose-600 text-white text-sm font-bold inline-flex items-center gap-1.5"><Share2 className="w-4 h-4" /> Teilen</button>
    </section>
  );
}

export function RebrandPopup() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const due = Boolean(user && !user.rebrand_seen && user.created_at && user.created_at < CUTOFF);
  useEffect(() => { if (due) whenFree("rebrand", () => setOpen(true)); }, [due]);
  if (!open) return null;
  const close = () => { setOpen(false); api.post("/growth/rebrand-seen").catch(() => {}); };
  return <Sheet onClose={close} />;
}
